export function formatTravelerDate(date: Date): string {
  if (date) {
    const newDate = new Date(date);
    const day = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getUTCFullYear();
    const mo = month < 10 ? `0${month}` : month;
    const da = day < 10 ? `0${day}` : day;
    return `${year}-${mo}-${da}`;
  } else return null;
}
